// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"9fbc4baf","197":"fac8db10","395":"c62b0ba7","401":"819c6c73","496":"57307047","822":"3ec1b565","873":"f807b809"}[chunkId] + ".chunk.js";
};